import '../../scss/theme.scss';
import '../../scss/gilroy_font.scss';
import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
import 'slick-carousel';

import '../sections/hotspots';
import '../overlay';
import '../drawers';
import '../cart';
import '../app';
import '../analytics';
import '../sections/header';
import '../sections/size_guide';
import '../sections/collection_products';
import '../sections/careers_life_carousel';
import '../sections/careers_what_we_offer';
import '../components/careers_job_listings';
import '../templates/collection';
import '../form_validation';
import '../dialogs';
import '../regionalise';
import '../currency';
import '../redirect';
import '../components/birth_date_field';
import '../components/smart_field';
import '../components/faq_shipping';
import '../components/read-more';
import '../components/file_dropzone';
import '../components/float_field';
import '../components/float_masked_field';
import '../components/float_phone_field';
import '../components/float_date_field';
import '../components/float_select';
import '../components/float_country'
import '../components/float_province';
import '../components/float_textarea';
import '../components/float_checkbox';
import '../components/float_country_province';
import '../components/float_dropdown';
import '../components/giveaway_form';
import '../components/giveaway_additional_form';
import '../components/modal_giveaway_form';
import '../components/new_customer_info_form';
import '../components/confetti_element';
import '../components/bouncing_ellipsis';
import '../components/scroll_fade';
import '../components/countdown_timer';
import '../components/size_guide_table';
import '../vendor/store-credit';
import '../components/collection_card';
import '../components/collection_filter';
import '../components/badges';
import '../components/toast';
import '../components/fabrication_calculator';
import '../components/bestie_bonus_form';
import '../components/click_to_copy';
import '../components/beauty_product_tile';
import '../components/beauty_siblings';
import '../components/wishlist';
import '../components/wishlist_button';
import '../components/product_card';
import '../components/wishlist_count';
import '../components/product_card_skeleton';
import '../components/wishlist_share_button';
import '../components/modal_wishlist_share';
import '../components/toast';
import '../components/modal_wishlist_create_board';
import '../components/modal_wishlist_delete_board';
import '../components/modal_wishlist_edit_board';
import '../components/modal_wishlist_move_to_board';
import '../components/modal_wishlist_add_notification';
import '../components/link_sharer';
import '../sections/wishlist_main';
import '../sections/wishlist_share';
import '../components/wishlist_create_board_form';
import '../components/wishlist_edit_board_form';
import '../components/wishlist_move_to_board_form';
import '../components/wishlist_toolbar';
import '../sections/nolayout_collections';
import '../components/cookie_banner';
import '../components/boilerplate_drawer';
import '../components/cookie_preference_category';
import '../components/drawer_cookie_preferences';
import '../components/cart_upsells';
import '../components/back_in_stock_button';
import '../components/back_in_stock_modal';
import '../components/back_in_stock_form';
import AnnouncementService from '../components/announcement_service';
import '../components/announcement_region';
import '../components/countdown_timer';
import '../components/video_component';
import '../components/tapcart_banner'

import '../components/whiskers_form';
import Geolocator from '../geolocator';
import WhiskersForm from '../components/whiskers_form';
import CountryProvinceSelector from '../components/country_province_selector';

window.geolocator = new Geolocator();

window.announcements = new AnnouncementService();

window.announcements.init();

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

var loadProductRecommendationsIntoSection = function () {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) {
    return;
  }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      $(".slick").slick({
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              infinite: false,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

// Initialise any phone inputs
document.addEventListener('DOMContentLoaded', function() {
  const inputs = document.getElementsByClassName('_mobile_number_input');

  let preferredCountries;
  try {
    preferredCountries = window.theme.telInputPreferredCountries;
  } catch (err) {
    console.error('Error setting preferred tel input countries', err);
    preferredCountries = ['au', 'nz'];
  }

  const initialiseTelInput = (input) => {
    if (input.classList.contains('_intl_initialised')) {
      console.log('Mobile input already initialised', input);
      return false;
    }

    const validator = window.intlTelInput(input, {
      separateDialCode: true,
      preferredCountries: preferredCountries,
      onlyCountries: ['au', 'nz', 'sg', 'hk', 'ca', 'at', 'be', 'hr', 'dk', 'fi', 'fr', 'de', 'gr', 'ie', 'it', 'lt', 'lu', 'nl', 'no', 'pl', 'pt', 'si', 'es', 'se', 'ch', 'hu', 'mt', 'sa', 'ae', 'gg', 'je', 'jp', 'mx', 'us', 'gb', 'za'],
      autoPlaceholder: 'aggressive'
    });

    input.classList.add('_intl_initialised');

    if (input.id) {
      window.intlTelInputValidators = window.intlTelInputValidators || {};
      window.intlTelInputValidators[input.id] = validator;
    }

    const handleMobileNumberChange = (e) => {
      try {
        const inAnIntlTelInput = input.parentElement.classList.contains('iti');
        const wrapper = input.closest('.mobile_input_wrapper');
        const prefix = wrapper.querySelector('.iti__selected-dial-code');
        const hiddenInput = wrapper.querySelector('input[type="hidden"]');

        if (!inAnIntlTelInput || !wrapper || !prefix || !hiddenInput) {
          return;
        }

        hiddenInput.value = `${ prefix.innerHTML }${ input.value }`;

        // console.log(hiddenInput.value);
      } catch(err) {
        console.warn('Error during mobile number change', err);
      }
    };

    ['change', 'countrychange'].forEach(function(e) {
      input.addEventListener(e, handleMobileNumberChange);
    });
  }

  window.initialiseTelInput = initialiseTelInput;

  Array.from(inputs).forEach(input => {
    initialiseTelInput(input);
  });
});

// Slick image carousels
const imageCarousels = Array.from(document.querySelectorAll('.image_carousel'));
if (imageCarousels.length > 0) {
  imageCarousels.forEach(el => {
    const { leftarrow } = el.dataset;
    $(el).slick({
      slidesToShow: 4,
      infinite: false,
      dots: false,
      arrows: true,
      ... leftarrow && leftarrow !== '' ? {
        prevArrow: `<button class="slick-prev" aria-label="Previous slide">
        <img src="${leftarrow}" alt="Previous">
      </button>`,
      nextArrow: `<button class="slick-next u_hflip" aria-label="Next slide">
        <img src="${leftarrow}" alt="Next">
      </button>`
      } : {},
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            arrows: true,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            arrows: true,
          },
        },
      ],
    });
  });
}

